import { render, staticRenderFns } from "./SidebarMenuBadge.vue?vue&type=template&id=c2397f2c&"
import script from "./SidebarMenuBadge.vue?vue&type=script&lang=js&"
export * from "./SidebarMenuBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports